import { useState } from "react";
import { faqItems } from "../../../mocks/siteData";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-white" id="faq">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">
          <div className="lg:col-span-2">
            <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-3">
              FAQ
            </span>
            <h2
              className="text-4xl lg:text-5xl font-semibold text-[#111111] leading-tight mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Interior Design Questions, Answered
            </h2>
            <p className="text-[#5C5C5C] leading-relaxed mb-8 text-[15px]">
              Common questions from homeowners looking for interior design planning, design proposals, and renovation guidance.
            </p>
            <div className="w-10 h-0.5 bg-[#C9A961]"></div>
          </div>

          <div className="lg:col-span-3">
            {faqItems.map((item, idx) => (
              <div key={idx} className="border-b border-[#F0EDE8]">
                <button
                  className="w-full flex items-center justify-between py-5 text-left cursor-pointer group"
                  onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                >
                  <span
                    className={`text-base font-medium leading-snug pr-4 transition-colors ${
                      openIndex === idx ? "text-[#C9A961]" : "text-[#111111] group-hover:text-[#C9A961]"
                    }`}
                  >
                    {item.question}
                  </span>
                  <div
                    className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-all ${
                      openIndex === idx ? "bg-[#C9A961] border-[#C9A961]" : "border border-[#E8E3DC]"
                    }`}
                  >
                    <i
                      className={`${openIndex === idx ? "ri-subtract-line text-white" : "ri-add-line text-[#111111]"} text-sm`}
                    ></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === idx ? "max-h-40 pb-5" : "max-h-0"
                  }`}
                >
                  <p className="text-[#5C5C5C] leading-relaxed text-sm">{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
